import React, { useRef } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import useExportChartImage from "../useExportChartImage";
import SaveButton from "../UI/SaveButton";
import { getCategoryLabelById } from "../../../utils/labelsById";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  ChartDataLabels
);

const isRange = (label) => {
  const rangePattern = /(\d+)\s*[-–]\s*(\d+)/;
  return rangePattern.test(label);
};

// Merr fillimin e rangut për ta përdorur në sortim
const getRangeStart = (label) => {
  const match = label.match(/(\d+)\s*[-–]\s*(\d+)/);
  if (match) return parseInt(match[1], 10);
  if (/Deri\s+ne\s+1/i.test(label)) return 0;
  if (/(\d+)/.test(label)) return parseInt(label.match(/(\d+)/)[1], 10);
  return Infinity;
};

// Bën renditjen vetëm nëse të paktën një label është range
const sortEntries = (entries) => {
  const hasRange = entries.some(
    ([label]) => isRange(label) || /Deri\s+ne\s+1/i.test(label)
  );
  if (!hasRange) return entries;

  return [...entries].sort((a, b) => getRangeStart(a[0]) - getRangeStart(b[0]));
};

const VerticalBarWithPercentage = ({ dataChart = {}, dataSetting, title }) => {
  const chartRef = useRef();
  const exportChartImage = useExportChartImage();
  const fileName = dataSetting?.name + "_" + dataSetting?.year;

  // Krijo të dhënat me renditje sipas range nëse aplikohet
  const entries = sortEntries(Object.entries(dataChart));

  const total = entries.reduce((sum, [, value]) => sum + value, 0);

  const chartData = {
    labels: entries.map(([label]) => label),
    datasets: [
      {
        data: entries.map(([, value]) => ((value / total) * 100).toFixed(2)),
        backgroundColor: "#EC2100", // Bar color
        borderRadius: 0,
        barThickness: 25,
        borderSkipped: false,
        datalabels: {
          anchor: "end",
          align: "end",
          color: "#000",
          font: {
            weight: "bold",
            size: 14,
          },
          formatter: (value) => `${value}%`,
        },
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (context) => `${context.label}: ${context.formattedValue}%`,
        },
      },
      datalabels: {
        display: true,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        max: 30,
        ticks: {
          callback: (val) => `${val}%`,
          stepSize: 5,
        },
        title: {
          display: false,
        },
        grid: {
          drawTicks: false,
        },
      },
      x: {
        ticks: {
          autoSkip: false,
          maxRotation: 0,
          minRotation: 0,
        },
        grid: {
          display: false,
        },
      },
    },
  };

  const handleExportImage = () => {
    exportChartImage({ chartRef, fileName, dataSetting });
  };

  return (
    <div>
      <div ref={chartRef}>
        {title && (
          <h3 style={{ marginBottom: "20px" }}>
            {getCategoryLabelById(title)}
          </h3>
        )}
        {/* {title && <h3 style={{ marginBottom: "20px" }}>{title}</h3>} */}
        <div style={{ width: "100%", maxWidth: "700px", marginBottom: "20px" }}>
          <Bar data={chartData} options={options} />
        </div>
      </div>
      <SaveButton onClick={handleExportImage} />
    </div>
  );
};

export default VerticalBarWithPercentage;
